import { CHANGE_TO_LIGHT, CHANGE_TO_DARK } from "../constants/actionCreators";

export const changeToLightTheme = () => {
    return {
        type: CHANGE_TO_LIGHT,
    };
};

export const changeToDarkTheme = () => {
    return {
        type: CHANGE_TO_DARK,
    };
};